import { ChevronRightIcon, CheckCircleIcon } from "@chakra-ui/icons";
import { Box, Flex, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const CompletedReadingOrdersCard = ({ franchise }) => (
  <LinkBox
    as={Box}
    mt="3"
    mb="2"
    p="3"
    borderWidth="1px"
    borderColor="#30384E"
    borderRadius="lg"
    bg="#151A30"
    _hover={{ borderColor: "gray.500" }}
  >
    <Flex align="center" gap="3">
      <Flex
        align="center"
        justify="center"
        flexShrink={0}
        boxSize="42px"
        borderWidth="2px"
        borderColor="green.500"
        borderRadius="full"
      >
        <CheckCircleIcon color="green.500" boxSize="5" />
      </Flex>
      <Box flex="1" minW="0">
        <LinkOverlay
          as={RouterLink}
          to={`/reading/completed?franchise=${franchise}`}
          fontWeight="bold"
          color="#F7F9FC"
        >
          Completed reading orders
        </LinkOverlay>
        <Text mt="0.5" color="#A8B2C8" fontSize="xs">
          Browse all the orders you have finished
        </Text>
      </Box>
      <Flex
        align="center"
        justify="center"
        flexShrink={0}
        boxSize="32px"
        borderRadius="full"
        bg="#222B45"
        color="#A8B2C8"
      >
        <ChevronRightIcon boxSize="5" />
      </Flex>
    </Flex>
  </LinkBox>
);

export default CompletedReadingOrdersCard;
